import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const SectionTitle = createComponent('h2', {
  className: `
      absolute
      left-0
      top-[-110px]
      w-full
      text-center
      text-[28px]
      font-black
      uppercase leading-none tracking-tight text-white
      s:top-[-90px] m:top-[-124px] m:text-[40px]
      l:top-[-156px]
      l:text-[54px]
    `
});

export const MountainPeakImg = createComponent('img', {
  className: `
    mb-[-5px]
    ml-[50%]
    max-h-[500px]
    min-h-[280px] min-w-[100vw]
    !max-w-[unset]
    -translate-x-1/2
    object-cover
    object-top m:min-h-[380px]
  `
});

export const VideoWrapper = createComponent('div', {
  className: `
      relative mx-auto flex
      max-h-[512px]
      max-w-[524px]
      items-center
      justify-center
      overflow-hidden
      rounded-xl l:max-w-[912px]
    `
});

export const VideoPlayer = createComponent('div', {
  className: 'aspect-video w-full'
});

interface PlaybackProps extends React.HTMLProps<HTMLElement> {
  shouldHide: boolean;
}

export const OverlayImageWrapper = createComponent<PlaybackProps>(
  'div',
  props => ({
    className: cx(
      `
        after:absolute
        after:inset-0
        after:bg-[#0D375E]
        after:opacity-40
        after:content-['']
      `,
      props.shouldHide ? 'hidden' : 'block'
    )
  })
);

export const OverlayImage = createComponent<PlaybackProps>('img', props => ({
  className: cx(
    'absolute inset-0 w-full',
    props.shouldHide ? 'hidden' : 'block'
  )
}));

export const PlaybackButton = createComponent<PlaybackProps>(
  'button',
  props => ({
    className: cx(
      'absolute rounded-full bg-transparent transition-opacity duration-150',
      props.shouldHide
        ? 'cursor-default opacity-0'
        : 'cursor-pointer opacity-100'
    )
  })
);

export const VideoDescription = createComponent('p', {
  className: `
      mx-auto max-w-[524px] px-24
      pb-56 pt-32 text-center
      text-grey-5 tl-body-m
      m:max-w-[524px] m:px-0 m:pb-80 m:pt-40
      l:max-w-[680px] l:pt-56 l:tl-body-l
    `
});
